// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3u1w8","ranges":"BmiRanges_ranges__WJeTj"};